'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-labelledby", "aria-describedby", "aria-invalid", "aria-label", "aria-required", "autoSelect", "buttonProps", "className", "defaultValue", "error", "id", "inputProps", "inputRef", "onChange", "onCopy", "required", "tooltipPlacement", "value", "valueWhenCopied"];
import styled from 'styled-components';
import { callIfPossible } from '../core/Functions';
import Controllable from '../decorators/Controllable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import classNames from 'classnames';
import UICopyButton from '../button/UICopyButton';
import UITextInput from '../input/UITextInput';
import UIMediaBody from '../layout/UIMediaBody';
import UIMediaObject from '../layout/UIMediaObject';
import ShareInput from '../decorators/ShareInput';
import refObject from '../utils/propTypes/refObject';
import { MERCURY_LAYER } from 'HubStyleTokens/sizes';
import { FieldsetContext } from '../context/FieldsetContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ElevatedMediaBody = styled(UIMediaBody).withConfig({
  displayName: "UICopyInput__ElevatedMediaBody",
  componentId: "sc-1fugt9t-0"
})(["z-index:", ";"], MERCURY_LAYER);
class UICopyInput extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleCopyClick = evt => {
      const {
        onCopy,
        inputRef
      } = this.props;
      if (inputRef.current) inputRef.current.select();
      callIfPossible(onCopy, evt);
    };
    this.handleInputMouseDown = evt => {
      const {
        autoSelect,
        inputRef
      } = this.props;
      if (autoSelect) {
        evt.preventDefault();
        if (inputRef.current) inputRef.current.select();
      }
    };
  }
  render() {
    const _this$props = this.props,
      {
        'aria-labelledby': ariaLabelledBy,
        'aria-describedby': ariaDescribedBy,
        'aria-invalid': ariaInvalid,
        'aria-label': ariaLabel,
        'aria-required': ariaRequired,
        buttonProps,
        className,
        defaultValue,
        error,
        id,
        inputProps,
        inputRef,
        onChange,
        required,
        tooltipPlacement,
        value,
        valueWhenCopied
      } = _this$props,
      props = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      size: fieldSize
    } = this.context;
    const ariaProps = {
      'aria-labelledby': ariaLabelledBy,
      'aria-describedby': ariaDescribedBy,
      'aria-invalid': ariaInvalid,
      'aria-label': ariaLabel,
      'aria-required': ariaRequired,
      id
    };
    return /*#__PURE__*/_jsx(UIMediaObject, Object.assign({}, props, {
      className: classNames("input-group private-form__group", className),
      spacing: "none",
      MediaBody: ElevatedMediaBody,
      itemRight: /*#__PURE__*/_jsx(UICopyButton, Object.assign({
        className: classNames('input-group-addon private-form__group--end', buttonProps && buttonProps.className),
        onClick: this.handleCopyClick,
        size: fieldSize,
        tooltipPlacement: tooltipPlacement,
        value: value,
        valueWhenCopied: valueWhenCopied
      }, buttonProps)),
      children: /*#__PURE__*/_jsx(UITextInput, Object.assign({
        "aria-readonly": !defaultValue,
        className: classNames('private-form__group--start', inputProps && inputProps.className),
        error: error,
        id: id,
        inputRef: inputRef,
        onChange: onChange,
        onMouseDown: this.handleInputMouseDown,
        required: required,
        type: "text",
        value: value
      }, ariaProps, inputProps))
    }));
  }
}
UICopyInput.displayName = 'UICopyInput';
UICopyInput.contextType = FieldsetContext;
UICopyInput.defaultProps = {
  autoSelect: true,
  tooltipPlacement: 'bottom'
};
UICopyInput.propTypes = {
  'aria-labelledby': PropTypes.string,
  'aria-describedby': PropTypes.string,
  'aria-invalid': PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-required': PropTypes.bool,
  autoSelect: PropTypes.bool.isRequired,
  buttonProps: PropTypes.object,
  defaultValue: PropTypes.string,
  error: PropTypes.bool,
  inputProps: PropTypes.object,
  inputRef: refObject,
  onChange: PropTypes.func,
  onCopy: PropTypes.func,
  required: PropTypes.bool,
  tooltipPlacement: UICopyButton.propTypes.tooltipPlacement,
  value: PropTypes.string,
  valueWhenCopied: PropTypes.func
};
export default ShareInput(Controllable(UICopyInput));